import { getContext } from '@fiverr-private/fiverr_context';
import { formatDate } from '@fiverr-private/futile';
import { HOURS_IN_DAY } from './constants';

export const formatAsLocalizedShortDate = (epochTime) => {
    const { locale } = getContext();

    return formatDate(new Date(epochTime), {
        locale,
        year: false,
    });
};

export const formatHoursAsDays = (hours) =>
    hours < HOURS_IN_DAY
        ? { key: 'collections_perseus.date.short_hours', count: hours }
        : { key: 'collections_perseus.date.days', count: Math.floor(hours / HOURS_IN_DAY) };
